module.exports = __webpack_public_path__ + "img/3.678729a1.png";